module.exports = "https://venezia-network.servercdn.it/static/img/clip.svg?7578fddb7b1ec8288d4227572b7ada1f";